var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SvgIcon, makeStyles } from "@material-ui/core";
import React from "react";
export default React.forwardRef((_a, ref) => {
    var { color = "primary", children, width, height, sizeRatio, className = "", transform } = _a, otherProps = __rest(_a, ["color", "children", "width", "height", "sizeRatio", "className", "transform"]);
    const classes = useStyles({
        color,
        width,
        height,
        sizeRatio,
        transform,
    });
    return (React.createElement(SvgIcon, Object.assign({ ref: ref, viewBox: `0 0 ${width} ${height}`, className: classes.root + " " + className }, otherProps), children));
});
const useStyles = makeStyles((theme) => ({
    root: ({ color = "inherit", width = 20, height = 20, sizeRatio = 1, transform, }) => ({
        width: width * sizeRatio,
        height: height * sizeRatio,
        color: color !== "inherit" ? theme.palette.icon[color] : "inherit",
        transform,
    }),
}));
//# sourceMappingURL=IconWrapper.js.map